import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DateFormats } from '@nk/utils-lib';
import { filter } from 'rxjs/operators';
import { LIST_ANIMATION } from '../../../utils/animations.utils';
import { NkToast, NkToastrService } from '../nk-toastr.service';

interface ActiveToast extends NkToast {
  timestamp: Date;
  id: number;
}

@Component({
  selector: 'nk-toastr',
  templateUrl: './nk-toastr.component.html',
  animations: [LIST_ANIMATION],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class NkToastrComponent implements OnInit {
  public toasts: ActiveToast[] = [];
  public toastColors = {
    error: 'text-danger',
    warning: 'text-warning',
    info: 'text-info',
    success: 'text-success',
  };
  public activeToasts: NkToast[] = [];
  public dateFormats = DateFormats;
  private _toastrService = inject(NkToastrService);
  private _destroy = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);

  public ngOnInit(): void {
    this._toastrService.toasts$
      .pipe(
        filter((x) => !!x),
        takeUntilDestroyed(this._destroy),
      )
      .subscribe((toast) => {
        if (toast) {
          if (toast.active) {
            this.activeToasts = [...this.activeToasts, toast];
          } else {
            this.activeToasts = this.activeToasts.filter((x) => toast.id !== x.id);
          }
          this._cdr.markForCheck();
        }
      });
  }

  public hideToast(toastId: number | undefined): void {
    if (toastId) {
      this._toastrService.hideToast(toastId);
    }
  }
}
